import { render, staticRenderFns } from "./ParkingSpace.vue?vue&type=template&id=fbaf7db0"
import script from "./ParkingSpace.vue?vue&type=script&lang=js"
export * from "./ParkingSpace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports